export enum ELocation {
  NONE = '',
  HOME = 'home',
  WORK = 'work',
  OTHER = 'other',
}
